/**
 * AccountStructureSection - TASK-371 (extracted from ClientProfileForm)
 * Section 5: Account structure type and details.
 */

import React from 'react';
import type { ClientProfileFormData } from './ClientProfileForm';

type AccountStructureData = ClientProfileFormData['account_structure'];

interface AccountStructureSectionProps {
  data: AccountStructureData;
  onChange: (field: string, value: any) => void;
}

export const AccountStructureSection: React.FC<AccountStructureSectionProps> = ({
  data,
  onChange,
}) => (
  <div className="px-4 pb-4 space-y-4">
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        Structure Type
      </label>
      <select
        value={data.structure_type || ''}
        onChange={(e) => onChange('structure_type', e.target.value || null)}
        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">Select structure</option>
        <option value="individual">Individual</option>
        <option value="joint">Joint Account</option>
        <option value="corporate">Corporate</option>
        <option value="trust">Trust</option>
        <option value="foundation">Foundation</option>
        <option value="partnership">Partnership</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        Structure Details
      </label>
      <textarea
        value={data.details || ''}
        onChange={(e) => onChange('details', e.target.value || null)}
        rows={3}
        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
        placeholder="Describe the account structure, related entities, and organizational details..."
      />
    </div>
  </div>
);

export default AccountStructureSection;
